import { useDriverTrackingState } from '.'
import { getRouteProperties } from '../components/DriverMap/util'
import type { DriverSchedule } from '../types'

export function setSelectedDriverId(driverId: string | null) {
  useDriverTrackingState.setState({ selectedDriverId: driverId })
}

export function setDriverOrdersOnRoute(orderNumber: number, color: string, arrow: string) {
  useDriverTrackingState.setState((state) => ({
    driverOrdersOnRoute: {
      ...state.driverOrdersOnRoute,
      [orderNumber]: { color, arrow, isVisible: false },
    },
  }))
}

export function setOrderVisibility(orderNumber: number, isVisible: boolean) {
  useDriverTrackingState.setState((state) => ({
    driverOrdersOnRoute: {
      ...state.driverOrdersOnRoute,
      [orderNumber]: { ...state.driverOrdersOnRoute[orderNumber], isVisible },
    },
  }))
}

export function clearOrdersOnRoute() {
  useDriverTrackingState.setState({ driverOrdersOnRoute: {} })
}

export function initializeOrdersOnRoute(driverSchedule: DriverSchedule | null | undefined) {
  driverSchedule?.assigned_orders?.forEach((order, index) => {
    const { color, arrow } = getRouteProperties(index)
    setDriverOrdersOnRoute(order.number, color, arrow)
  })

  let currOrderIndex = driverSchedule?.assigned_orders?.findIndex(
    (order) => order.number === driverSchedule?.last_update?.detail?.order_number
  )
  if (currOrderIndex === undefined || currOrderIndex === -1) {
    currOrderIndex = 0
  }
  driverSchedule?.assigned_orders?.forEach((order, index) => {
    setOrderVisibility(order.number, index === currOrderIndex)
  })
}
